var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkIfIconExists(_vm.name))?_c(_vm.name,{tag:"component",staticClass:"spaces-icon",class:("spaces-icon--" + _vm.name)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }